// extracted by mini-css-extract-plugin
export default {"main":"AdminNavbar_main__CKF95"};